import { get, post } from '@/utils/http';
import api from '@/api';
import { message } from 'ant-design-vue';
import {
  setAccount,
  setUserZnEnv,
  setToken,
  setUserSys,
  // eslint-disable-next-line import/extensions
} from '../login/login-handler.js';
import { getUiFitment } from '@/utils/accessResources';

const { envList } = require('../../../config/dev.proxy');

class ApprovalClass {
  /**
   * 0=登录失败
   * 1=登录中
   * 2=前置成功，等待再次打开
   */
  options = 1;

  args = {
    // workflowId: '2177569', // 流程id
    // taskId: '2177630', // 任务ID
    // act: 'todo', // 表示哪种数据，待办/已办/我发起的/抄送
    // appType: '1', // 终端类型 1pc 2h5
    // znAppId: '90001', // 登陆需要使用的appId
    // rf: '0', // pc端需要的参数，0表示不自动跳转，1表示自动跳转

    // domain: 'https://farm-xn-dev.znlh.work/',
    // path: 'process/detail?objectId=102&layoutApiKey=detail',
    // approval: '',
    // bizId: '1120378166500528128',
    // routeUrl: null,
    // routeParams: null,
  };

  // 飞书登录接口返回
  urlRes = {};

  // 用户权限查询信息接口返回
  urlLoginRes = {};

  constructor() {
    if (typeof ApprovalClass.instance === 'object') {
      return ApprovalClass.instance;
    }
    ApprovalClass.instance = this;
    this.init();
  }

  /**
   * 初始化
   * @return
   */
  // eslint-disable-next-line class-methods-use-this
  init() {
    this.args = this.getQueryStringSource();
  }

  // eslint-disable-next-line class-methods-use-this
  initenv() {
    let isProduct = true;
    envList.forEach((m) => {
      if (window.location.hostname.toString().includes(m)) {
        isProduct = false;
        setUserZnEnv(m);
      }
    });
    if (isProduct) {
      setUserZnEnv('product');
    }
    setUserSys(this.args.znAppId);
  }

  /**
   * 解析url 返回参数
   * @return args
   *
   */
  // eslint-disable-next-line class-methods-use-this
  getQueryStringSource(url) {
    // eslint-disable-next-line no-restricted-globals
    let qs = '';
    if (!url) {
      qs = window.location.search.length > 0 ? window.location.search.substring(1) : '';
    } else {
      qs = url;
    }
    // eslint-disable-next-line prefer-const
    let args = {};
    // eslint-disable-next-line prefer-const
    let items = qs.length ? qs.split('&') : [];
    let item = null;
    let name = null;
    let value = null;
    let i = 0;
    const len = items.length;
    // eslint-disable-next-line no-plusplus
    for (i = 0; i < len; i++) {
      item = items[i].split('=');
      name = decodeURIComponent(item[0]);
      value = decodeURIComponent(item[1]);
      if (name.length) {
        args[name] = value;
      }
    }
    return args;
  }

  /**
   * 跳转指定页面
   * type:只有点击跳转存在
   */
  toProcessPage(type) {
    try {
      // eslint-disable-next-line eqeqeq
      if (this.args.rf == 1 || type == 1) {
        // eslint-disable-next-line eqeqeq
        window.open(`http://${this.args.domain}/push?data=${this.directJump()}`, '_self');
        // eslint-disable-next-line no-empty
      }
      // eslint-disable-next-line eqeqeq
      if (type == 1) {
        window.open(`http://${this.args.domain}/push?data=${this.directJump()}`, '_blank');
      }

    } catch (error) {
      this.options = 0;
    }
  }

  directJump() {
    // approval存在 增加fromObjectLayoutApiKey ='todoList'
    const params = this.getQueryStringSource(this.args.path.split('?')[1]);
    // id存在 就增加data
    // eslint-disable-next-line camelcase
    const url_data = {
      apiKey: params.layoutApiKey,
      id: this.args.bizId,
    };
    // eslint-disable-next-line no-unused-expressions
    this.args.bizId ? params.data = encodeURIComponent(JSON.stringify(url_data)) : null;
    // eslint-disable-next-line no-unused-expressions
    this.args.approval ? params.fromObjectLayoutApiKey = 'todoList' : null;
    // eslint-disable-next-line no-unused-expressions
    this.args.taskId ? params.fromObjectTaskId = this.args.taskId : null;
    const firstPath = this.args.path.split('?')[0].charAt(0);
    // eslint-disable-next-line no-underscore-dangle
    const _this = this;

    return encodeURIComponent(JSON.stringify({
      url_res: _this.urlRes,
      url_login_res: _this.urlLoginRes,
      path: `${firstPath !== '/' ? '/' : ''}${this.args.path.split('?')[0]}`,
      query: params,
    }));
  }

  // 飞书审批获取业务参数及url
  routerParam() {
    // this.toProcessPage();
    // return;
    // eslint-disable-next-line no-underscore-dangle
    const _this = this;
    const params = {
      workflowId: this.args.workflowId,
      taskId: this.args.taskId,
      act: this.args.act,
      znAppId: this.args.znAppId,
    };
    get(api.routerParam, params)
      .then((res) => {
        _this.args = { ...this.args, ...res };
        _this.options = 2;
        _this.toProcessPage();
      })
      .catch(() => {
        _this.options = 0;
      });
  }

  // 飞书登录-获取权限流程
  flyingBookLogin() {
    this.options = 1;
    post(api.flyingBookLogin, {
      code: this.args.code || '',
      state: this.args.state || '',
    }).then((res) => {
      setToken(res);
      this.getLoginAccount(res);
    }).catch(() => {
      this.options = 0;
    });
  }

  getLoginAccount(loginRes) {
    post(api.loginAccount, {}).catch(() => {
      message.error('用户信息查询失败');
      this.options = 0;
    })
      .then((res) => {
        this.urlRes = loginRes;
        this.urlLoginRes = res;
        // 之后缓存菜单需要参数
        setAccount(res, loginRes);
        getUiFitment().finally(()=>{
          if (res.id) {
            this.routerParam();
          } else {
            this.options = 0;
          }
        })
      })
      .catch(() => {
        this.options = 0;
      });
  }
}

export default ApprovalClass;
